module.exports = __webpack_public_path__ + "static/media/totalTeamsIcon.7379a98c.svg";